'use strict';

(function ($) {
    $.agito = $.agito || {};
    $.agito.dialogHelper = $.agito.dialogHelper || {};

    $.ajaxSetup({ cache: false });

    $.agito.dialogHelper.loadData = function (dialogSelector, url, callback, hidden, data) {
        if (!hidden) {
            hidden = false;
        }

        var $dialog = $(dialogSelector).filter('.modal');

        var lockToken = window.agPageFocusStack && window.agPageFocusStack.length > 0
            ? {
                page: window.agPageFocusStack[window.agPageFocusStack.length - 1],
                token: window.agPageFocusStack[window.agPageFocusStack.length - 1].lock()
            }
            : undefined;

        // init page model
        require(["Scripts/PlatformScripts/PageViewModel"], function (viewModel) {
            new viewModel.default($dialog[0]);

            var $content = $dialog.find('.modal-content');

            $content.empty();

            $content = $dialog.find('.modal-content');

            $content.load(url, data, function (r, s, x) {
                try {
                    var sessionExpired = AjaxHelpers.HandleExpiredSession(x);
                    if (!hidden && !sessionExpired) {
                        // show dialog
                        $dialog.modal();
                    }
                    else if (sessionExpired) {
                        return;
                    }

                    // create standardized header
                    var $content = $(this);
                    var $header = $content.children('div.modal-header');
                    if ($header.length === 0) {
                        $content.prepend($('<div class="modal-header"><button type="button" class="close" onclick="$.agito.dialogHelper.closeDialog($(this).closest(\'.modal\'))" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title"></h4></div>'));
                    } else {
                        $header.not(':has(> button.close)').prepend($('<button type="button" class="close" onclick="$.agito.dialogHelper.closeDialog($(this).closest(\'.modal\'))" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>'));
                        $header.not(':has(> .modal-title)').prepend($('<h4 class="modal-title"></h4>'));
                    }

                    // initialize controls inside dialog
                    if ($.agito.igHelper) {
                        $.agito.igHelper.initializeIgEditors(dialogSelector);
                    }
                    if ($.agito.controlsHelper) {
                        $.agito.controlsHelper.initializeAgitoControls(dialogSelector);
                    }

                    // set focus
                    if ($.agito.utilities && $.agito.utilities.setFocus) {
                        $dialog.one('loaded.ag.modal', function () {
                            $.agito.utilities.setFocus($dialog.find('div.modal-body'));
                            if ($dialog.find(':focus').length === 0) {
                                $.agito.utilities.setFocus($dialog.find('div.modal-footer'));
                            }
                            if ($dialog.find(':focus').length === 0) {
                                $.agito.utilities.setFocus($dialog.find('div.modal-header'));
                            }
                        });
                    }

                    // parse form
                    if ($.validator && $.validator.unobtrusive) {
                        $.validator.unobtrusive.parse(dialogSelector);
                    }

                    $dialog.trigger('loaded.ag.modal');

                    if (callback) {
                        callback($dialog);
                    }

                    /* mark page as ready, but after a concrete delay to allow for all custom javascript to load */
                    $(function () {
                        $(function () {
                            $(function () {
                                $(function () {
                                    $(function () {
                                        $(function () {
                                            $(function () {
                                                $(function () {
                                                    $dialog[0].agPageModel.unlock('init-lock');
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });

                    return $dialog;
                }
                finally {
                    if (lockToken) {
                        lockToken.page.unlock(lockToken.token);
                    }
                }
            });
        });  
    };

    $.agito.dialogHelper.closeDialog = function (dialogSelector) {
        $(dialogSelector).filter('.modal').modal('hide');
    };

    $.agito.dialogHelper.draggableDialog = function (dialogSelector) {
        $(dialogSelector).filter('.modal').draggable({
            handle: ".modal-header"
        });
    };

    $.agito.dialogHelper.submitForm = function (dialogSelector, reloadOnSuccess, successCallback, failureCallback) {

        var $dialog = $(dialogSelector).filter('.modal');
        var $form = $dialog.find('form');
        var button = $dialog.find('.btn-submit');
        if (!$form.valid()) {
            $(button).prop('disabled', false);
            return;
        };

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',

            data: new FormData($form[0]),
            cache: false,
            contentType: false,
            processData: false
        })
            .done(function (data) {

                $(button).prop('disabled', false);

                if (data != null && data.hasOwnProperty('success')) {
                    if (!data.success) {

                        var messagesPlaceholder = $dialog.find('.hrm-page-messages-placeholder');

                        if (messagesPlaceholder.length > 0)
                            $.agito.hrmPage.handleAjaxError(messagesPlaceholder, data);
                        else
                            alert(data.message);

                        return;
                    }
                    else if (typeof data.message != "undefined") {
                        var messagesPlaceholder = $('.hrm-page-placeholder .hrm-page-messages-placeholder').first();

                        if (messagesPlaceholder.length > 0)
                            $.agito.hrmPage.handleAjaxError(messagesPlaceholder, data);
                        else
                            alert(data.message);
                    }
                }

                $(window).trigger('ag.data.changed');

                $dialog.modal('hide');
                if ($.isFunction(successCallback)) {
                    successCallback.call(this, data);
                }
                if (!!reloadOnSuccess) {
                    window.location.href = window.location.href;
                }
            }).fail($.isFunction(failureCallback) ? failureCallback : function (jqXHR, textStatus) {
                // TODO translate
                //var msg = 'Error has occured: ';
                //alert(msg + jqXHR.status + " " + jqXHR.statusText);
            });
    };
})($);